import React, { Component } from "react";
import { Container, Row, Col, Form } from "react-bootstrap"
import { TableCell, TableRow } from "@mui/material";
import axios from "axios";
import Checkbox from '@mui/material/Checkbox';
import { debounceFunc } from './../../../helper'
import PhoneClinicGrid from "../../../Components/PhoneClinicGrid";
import RowActions from "../../../Components/PhoneClinicGrid/RowActions";
import FormCard from '../shared/FormCard';

class ItemCategory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            CategoryList: [],
            addCategory: false,
            ItemCategoryID_PK: "",
            ItemCategory: "",
            Active: "1",
            CATEGORY_SEARCH: ""
        };
        this.gridRef = React.createRef(null);
    }

    // componentDidMount() {
    //     let { CATEGORY_SEARCH, searchGridData, totalRecordsPerPage, paginationValue } = this.state
    //     this.getCategoryList(CATEGORY_SEARCH, searchGridData, totalRecordsPerPage.value, paginationValue)
    // }

    async getCategoryList(searchData = [], pagination = { recordOffset: 1, pageSize: 50 }) {
        this.props.toggleLoader(true)
        let formData = {
            // PC_SP_ID: localStorage.getItem('PC_GRP_ATT') || 0,
            searchData,
            pageSize: pagination.pageSize,
            recordOffset: pagination.recordOffset
        };

        const getDevice = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/Setups/ItemCategory.php`, formData);
        let deviceData = getDevice.data
        let CategoryList = []
        if (deviceData.success === 1) {
            CategoryList = deviceData.data
            pagination.totalItems = parseInt(deviceData.Page_count[0]['TOTAL_PAGE_COUNT'])
            pagination.totalPages = Math.ceil(pagination.totalItems / pagination.pageSize || 50)
            this.gridRef.current?.setPaginationData(pagination)
        }
        this.setState({ CategoryList })
        this.props.toggleLoader(false)
    }

    handleAddCategory() {
        this.setState({ addCategory: true })
    }

    handleChangeInput(fieldName, event) {
        let targetValue = event.target.value
        // switch (fieldName) {
        //     case "DEVICE_TYPE":
        //         targetValue = event
        //         break;

        //     default:
        //         targetValue = event.target.value
        //         break;
        // }
        this.setState({ [fieldName]: targetValue })
    }

    handleExit() {
        this.setState({
            addCategory: false,
            ItemCategoryID_PK: "",
            ItemCategory: "",
            Active: "1",
        })
    }

    async handleSubmitDevice() {
        this.props.toggleLoader(true)
        let formData = {
            ItemCategoryID_PK: this.state.ItemCategoryID_PK,
            ItemCategory: this.state.ItemCategory,
            Active: this.state.Active,
        }
        await axios.post(`${process.env.REACT_APP_BASE_URL}services/mutation/Setups/ItemCategory.php`, formData);
        this.handleExit()
        this.getCategoryList()
    }


    handleEdit(indx) {
        let { CategoryList } = this.state
        this.setState({
            ItemCategoryID_PK: CategoryList[indx]['ItemCategoryID_PK'],
            ItemCategory: CategoryList[indx]['ItemCategory'],
            Active: CategoryList[indx]['Active'],
            addCategory: true
        })
    }

    render() {
        return (
            <Container>
                {this.state.addCategory === false ?
                    <PhoneClinicGrid
                        title="CATEGORY"
                        buttonLabel="Add Category"
                        getData={this.getCategoryList.bind(this)}
                        onClickButton={this.handleAddCategory.bind(this)}
                        isEditable={true}
                        ref={this.gridRef}
                        tableHeadData={[
                            {
                                label: "CATEGORY",
                                isHidden: false
                            },
                            {
                                label: "ACTIVE",
                                isHidden: false
                            },
                        ]}
                    >
                        {this.state.CategoryList.map((device, idx) => (
                            <TableRow
                                key={idx}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                style={{ whiteSpace: 'nowrap' }}
                            >
                                <TableCell align='left'>{device.ItemCategory}</TableCell>
                                <TableCell align='center'>
                                    <Checkbox style={{ padding: "0px" }} size="small" checked={device.Active === "1" ? true : false} disabled />
                                </TableCell>
                                <TableCell align='center'>
                                    <RowActions actions={[
                                        { type: 'edit', onClick: this.handleEdit.bind(this, idx) },
                                    ]} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </PhoneClinicGrid>
                    :
                    <>
                        <FormCard title={this.state.ItemCategoryID_PK ? 'Edit Category' : 'Add Category'} mode={this.state.ItemCategoryID_PK ? 'edit' : 'new'}
                            onCancel={this.handleExit.bind(this)}
                            onSave={this.handleSubmitDevice.bind(this)} saveLabel="Save">
                        <Row>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control
                                        value={this.state.ItemCategory}
                                        name={"ItemCategory"}
                                        onChange={this.handleChangeInput.bind(this, "ItemCategory")}
                                       
                                    />
                                </Form.Group>
                            </Col>
                            {/* <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Brand</Form.Label>
                                    <Form.Control
                                        value={this.state.DEVICE_BRAND}
                                        name={"DEVICE_BRAND"}
                                        onChange={this.handleChangeInput.bind(this, "DEVICE_BRAND")}
                                       
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Model</Form.Label>
                                    <Form.Control
                                        value={this.state.DEVICE_NAME}
                                        name={"DEVICE_NAME"}
                                        onChange={this.handleChangeInput.bind(this, "DEVICE_NAME")}
                                        style={{ width: "100%" }}
                                    />
                                </Form.Group>
                            </Col> */}
                        </Row>
                        </FormCard>
                    </>
                }
            </Container>
        );
    }
}

export default ItemCategory;